import { useEffect, useState, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { Toaster } from 'sonner'
import { I18nProvider } from '@lingui/react'
import { queryClient } from '@/shared/lib/queryClient'
import { EnvRibbon } from '@/shared/components/EnvRibbon'
import { InstallPrompt } from '@/shared/components/InstallPrompt'
import { i18n, activateLocale, defaultLocale } from '@/i18n'

function I18nLoader({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    activateLocale(defaultLocale).then(() => setReady(true))
  }, [])

  if (!ready) return null

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NuqsAdapter>
          <I18nLoader>
            {children}
            <Toaster position="top-center" richColors />
            <InstallPrompt />
            <EnvRibbon />
          </I18nLoader>
        </NuqsAdapter>
      </BrowserRouter>
      {/* TanStack devtools disabled for now */}
    </QueryClientProvider>
  )
}
